/**
 * Runtime env access.
 *
 * CRA bakes process.env.REACT_APP_* at build time, so values are frozen
 * inside the bundle. To swap config per-environment without rebuilding the
 * image, public/env-config.js is regenerated by docker-entrypoint.sh from
 * the container's env vars and populates `window._env_` before the bundle
 * loads.
 *
 * Resolution order: window._env_ (runtime) -> process.env (dev fallback).
 */
type EnvKey =
  | 'REACT_APP_API_URL'
  | 'REACT_APP_GRAPHQL_ENDPOINT'
  | 'REACT_APP_SELF_URL'
  | 'REACT_APP_FIREBASE_API_KEY'
  | 'REACT_APP_FIREBASE_AUTH_DOMAIN'
  | 'REACT_APP_FIREBASE_PROJECT_ID'
  | 'REACT_APP_FIREBASE_STORAGE_BUCKET'
  | 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID'
  | 'REACT_APP_FIREBASE_APP_ID';

declare global {
  interface Window {
    _env_?: Partial<Record<EnvKey, string>>;
  }
}

export const getEnv = (key: EnvKey): string | undefined => {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
};
